// Portfolio — exactly 3 items (per spec). Logos/identifying info blurred on portfolio_3 (Potty Doctor).

export const PORTFOLIO = [
    {
        title: "South Florida Roofing Pro",
        category: "Functional Website + SEO + Reviews",
        image: "/assets/portfolio_1.png",
        accent: "Roofing",
    },
    {
        title: "Plumbing Co. — South Florida",
        category: "Functional Website + Missed Call Text-Back",
        image: "/assets/portfolio_2.png",
        accent: "Plumbing",
    },
    {
        title: "Drain & Sewer Specialist",
        category: "Local SEO + Review Funnel + Unified Inbox",
        image: "/assets/portfolio_3.png",
        accent: "Plumbing",
    },
];
